/**
 * Created by oleturvoll on 9/5/17.
 */

import {isolarAnalyticsSimpleData} from '../../meter/isolarAnalyticsSimpleData';
import {solarAnalyticsSummary} from '../../meter/solarAnalyticsSummary';
import {Chart} from 'angular-highcharts';

export class highChartSummary extends solarAnalyticsSummary {

  chart: Chart;

  constructor(data: isolarAnalyticsSimpleData[]){
    super(data);

    // this.logger.log.debug('highChartSummary constructor');
    // this.logger.log.debug(this.timestamps);
    // this.logger.log.debug(this.consumed);
    // this.logger.log.debug(this.generated);

    this.chart = this.getAreaChart();
  }

  //all graph data

  getAreaChart(): Chart {

    return new Chart({
      chart: {
        type: 'area',
        zoomType: 'x'
      },
      title: {
        text: 'Consumed vs Generated Energy',
        style: {
          color: '#616161',
          textTransform: 'uppercase',
          fontSize: '20px'
        }
      },
      subtitle: {
        text: 'Click and drag in the plot area to zoom in'
      },
      tooltip: {
        shared: true,
        backgroundColor: 'rgba(97,97,97,0.2)',
        style: {
          color: '#616161'
        }
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, 'rgba(97,97,97,0.2)'],
              [1, 'rgba(255,241,118,0.2)']
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        }
      },
      xAxis: {
        categories: this.getXAxis(true),
        type: 'datetime',
        gridLineColor: '#616161',
        title: {
          style: {
            color: '#616161'

          }
        }
      },
      yAxis: {
        title: {
          text: 'kWh'
        }
      },
      series: [{
        name: 'Consumed',
        color: '#616161',
        data: this.getConsumedData()
      }, {
        name: 'Generated',
        color: '#fff176',
        data: this.getGeneratedData()
      },]
    });
  }

  //TODO: create a theme variable



}


// WEBPACK FOOTER //
// ./src/model/graphing/highsoft/highChartSummary.ts